export default "__VITE_ASSET__3e49ec4d__"